
export default () => ({
  nameField: { maxWidth: 500 },
  card: { width: '100%' },
});
